import { Text } from '@bbl-digital/snorre'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { MessageTypeEnum } from 'Modules/Communication/shared/models/Recipients'
import { FC } from 'react'
import { useAppSelector } from 'shared/store/store'
import { getEmailRecipientsWithInvalidCount } from 'shared/store/sendMessage/email/selectors'
import { getSmsRecipientsWithInvalidCount } from 'shared/store/sendMessage/sms/selectors'

interface IProps {
  messageType: MessageTypeEnum
  recipientType: RecipientTypeEnum
}

const RecipientCounter: FC<IProps> = ({ messageType, recipientType }) => {
  const isEmail = messageType === MessageTypeEnum.Email

  const emailRecipients = useAppSelector(
    getEmailRecipientsWithInvalidCount(recipientType)
  )
  const smsRecipients = useAppSelector(
    getSmsRecipientsWithInvalidCount(recipientType)
  )

  const recipientsByType = isEmail ? emailRecipients : smsRecipients

  if (!recipientsByType.recipients.length) {
    return null
  }

  return (
    <Text italic small>
      {recipientsByType.recipients.length} mottakere{' '}
      {recipientsByType.invalidOrDuplicate > 0 &&
        `(${recipientsByType.invalidOrDuplicate} duplikat/uten gyldig ${
          isEmail ? 'e-post' : 'telefon'
        })`}
    </Text>
  )
}

export default RecipientCounter
